import { Flex, Typography } from "@papercup-ai/orizuru";

export const LoadingPage = (props: any) => (
  <Flex
    width={"100%"}
    justifyContent={"center"}
    alignItems={"center"}
    css={
      // if there's a height prop, that'll be used by ...props, so don't add the inline style setting height to 100vh
      !props.height
        ? {
            height: "100vh"
          }
        : undefined
    }
    {...props}
  >
    <Typography variant={"heading1"}>
      {props.message !== undefined ? props.message : "Loading..."}
    </Typography>
  </Flex>
);
